module.exports = __webpack_public_path__ + "img/box_pro_five_3.f9813111.jpg";